import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import { generalIntl } from "./generalIntl";
import { indexText } from "../../components/Results/indexText";

function Report(props) {
  return (
    <Row className="survey_content_container">
      <Col md={{ span: 16, offset: 4 }} xs={24}>
        <Row gutter={16}>
          <Col md={24} style={{ marginBottom: "20px" }}>
            <h1 style={{ marginBottom: 0, color: "#fff" }}>
              {generalIntl.headline[props.language]}
            </h1>
            <p style={{ fontSize: "18px" }}>
              {generalIntl.subheadline[props.language]}
            </p>
          </Col>
        </Row>
      </Col>
      <Col md={{ span: 16, offset: 4 }} xs={{ span: 20, offset: 2 }}>
        {indexText[props.language]}
      </Col>
    </Row>
  );
}

function mapStateToProps(state) {
  return {
    language: state.preference.language
  };
}

export default connect(mapStateToProps)(Report);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/Report.js